import {
	CONSENT_CATEGORIES,
	CONSENT_VERSION,
	type ConsentCategory,
	type ConsentRecord,
	DEFAULT_CONSENT_CATS,
} from "./constants";

export function buildDecidedConsentRecord(
	partial?: Partial<Record<ConsentCategory, boolean>>,
): ConsentRecord {
	const cats = { ...DEFAULT_CONSENT_CATS, ...partial };
	cats.necessary = true;
	return {
		v: CONSENT_VERSION,
		ts: Date.now(),
		cats,
	};
}

export function isValidConsentRecord(raw: unknown): raw is ConsentRecord {
	if (!raw || typeof raw !== "object") {
		return false;
	}
	const r = raw as Partial<ConsentRecord>;
	if (r.v !== CONSENT_VERSION || typeof r.ts !== "number") {
		return false;
	}
	if (!r.cats || typeof r.cats !== "object") {
		return false;
	}
	for (const c of CONSENT_CATEGORIES) {
		if (typeof r.cats[c] !== "boolean") {
			return false;
		}
	}
	return true;
}

export function parseConsentCookieValue(
	value: string | undefined | null,
): ConsentRecord | null {
	if (value == null || value === "") {
		return null;
	}
	try {
		const parsed: unknown = JSON.parse(value);
		if (!isValidConsentRecord(parsed)) {
			return null;
		}
		return parsed;
	} catch {
		return null;
	}
}

export function serializeConsentRecord(record: ConsentRecord): string {
	return JSON.stringify(record);
}
